<template>
  <div class="nx-message-body-editor">
    <label>{{ label|capitalize }}</label>
    <nx-advanced-editor
      :name="name"
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      :disabled="disabled"
      :hint="hint"
      data-vv-value-path="value"
      v-validate:value="validation"
      :value="value"
      :options="options"
      @input="onInput"
    ></nx-advanced-editor>
    <div class="input-group__details">
      <div class="input-group__messages">
        <div
          :key="index"
          class="input-group__error"
          v-for="(message, index) in errorMessages"
          v-html="message">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FormElement from '@/modules/form/mixins/form-element';
import AdvancedEditor from '@/components/texteditor/advanced/AdvancedEditor';

import ImageButton from '@/components/texteditor/advanced/buttons/ImageButton';
import CodeButton from '@/components/texteditor/advanced/buttons/CodeButton';
import TwitterButton from '@/components/texteditor/advanced/buttons/TwitterButton';
import YoutubeButton from '@/components/texteditor/advanced/buttons/YoutubeButton';

export default {
  name: 'nx-message-body-editor',
  extends: FormElement,
  components: {
    [AdvancedEditor.name]: AdvancedEditor,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    hint: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Object,
    },
  },
  methods: {
    onInput(data) {
      this.$parent.updateField(this.name, data);
    },
  },
};
</script>
<style lang="stylus">
.nx-message-body-editor {
  background-color: #f7f7fa;
  border-color: #f7f7fa;
  color: #8c8c9c;
  caret-color: #8c8c9c;
  padding-top 15px;

  label {
    margin-left: 15px;
  }
}
</style>
